import React from 'react';
import { useSelector } from 'react-redux';
import { colorsHouseholdByIncome } from '../../../../shared/constants';
import { GenericChartCard } from '../../../../component/charts/genericChartCard';
import { HouseholdByIncome } from '../../charts/types';
import { ErrorState } from './errorState';
import { generateTitleAndSource } from './socioeconomicDemographicCharts';
import nls from '../nls/pt-BR.json';
import { useSocioeconomicChartsData } from '../../../../hooks/useSocioeconomicChartsData';

export const HouseholdsByIncome: React.FC = () => {
  const { errorFetchData } =
    useSelector((state: any) => state.socioeconomicDemographicState) || '';
  const { householdsByIncome } = useSocioeconomicChartsData();
  const tableData = householdsByIncome
    ? (Object.entries(
        householdsByIncome
      ).reverse() as Entries<HouseholdByIncome>)
    : [];
  type PickByValue<T, V> = Pick<
    T,
    { [K in keyof T]: T[K] extends V ? K : never }[keyof T]
  >;

  type Entries<T> = {
    [K in keyof T]: [keyof PickByValue<T, T[K]>, T[K]];
  }[keyof T][];
  return (
    <GenericChartCard
      title={generateTitleAndSource(
        nls.charts.householdsByIncome.householdsByIncome,
        nls.disclaimers.dataSourceIBGE2010
      )}
    >
      {errorFetchData?.householdsByIncome ? (
        <ErrorState />
      ) : (
        <table>
          <tr>
            <th></th>
            <th>{nls.charts.householdsByIncome.numberResidences}</th>
            <th>{nls.charts.householdsByIncome.averageIncome}</th>
          </tr>
          {(tableData || []).map((household, index) => {
            return (
              <tr key={index}>
                <td>
                  <div
                    style={{
                      backgroundColor: colorsHouseholdByIncome[index],
                    }}
                    className="color-household"
                  />
                  {household[0]}
                </td>
                <td>{household[1].households_count}</td>
                <td>{household[1].weighted_avg_income}</td>
              </tr>
            );
          })}
        </table>
      )}
    </GenericChartCard>
  );
};
